
<style>
.modal-backdrop.fade.show {
    display: none;
}

a.btn-primary {
    background-color: #4FA0D5;
    border: none;
    border-radius: 8px;
    padding: 15px 46px;
    font-weight: 700;
    color: #FFFFFF;
}
</style>

<template>
    <div class="webinar-video-container container-space-y">
        <div class="container pt-5">
            <div class="row text-center">
                <div class="col-md-12 col-xs-12">
                    <img class="img-responsive alt-adjust my-5"
                        src="https://nxmcdn.com/images/NXM/vo-assets/nxm-logo-new.png" alt="NaXum Logo">
                    <div class="embed-responsive embed-responsive-16by9">
                        <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/NvzK-uzAZmM"
                            title="YouTube video player" allowfullscreen></iframe>
                    </div>
                </div>
                <div class="col-md-12 col-xs-12">
                    <div class="buttons-container text-center">
                        <a href="/" class="btn btn-primary m-2 w-25">SHOP NOW</a>
                        <a href="/" class="btn btn-primary m-2 w-25">JOIN NOW</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>



<script>
export default {
    name: 'WebinarVideo',
};
</script>
